module.exports = __webpack_public_path__ + "media/img/event/S2U_MastHead-46427db2b69b58929450e23cb4a8b022.png";